import classNames from 'classnames';
import { LabelBodyHeadline } from './LabelBodyHeadline';
import { LabelBody } from './LabelBody';

type Props = {
    image: React.ReactNode;
    imageHeight?: string;
    title: string;
    body?: string;
    className?: string;
};
export function AnnotatedIllustration({
    image,
    imageHeight = 'h-[200px]',
    title,
    body,
    className,
}: Props) {
    return (
        <div
            className={classNames(
                className,
                'flex h-full flex-col text-center',
            )}
        >
            <div
                className={classNames(
                    'mb-20 flex items-center justify-center',
                    imageHeight,
                )}
            >
                {image}
            </div>
            <LabelBodyHeadline>{title}</LabelBodyHeadline>
            {body && <LabelBody>{body}</LabelBody>}
        </div>
    );
}
